import { render } from "./WorkerRegisterLitterView.vue?vue&type=template&id=4fcdfb97&scoped=true"
import script from "./WorkerRegisterLitterView.vue?vue&type=script&lang=js"
export * from "./WorkerRegisterLitterView.vue?vue&type=script&lang=js"

import "./WorkerRegisterLitterView.vue?vue&type=style&index=0&id=4fcdfb97&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcdfb97"]])

export default __exports__